module.exports = __webpack_public_path__ + "teqbahn-assets/media/6.089ecf08.jpg";